import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EggIcon(props: IconProps) {
    return <Icon {...props} iconKey={"egg"}/>
}
